// extracted by mini-css-extract-plugin
export default {"container":"FullscreenContent_container__nEDNP","close":"FullscreenContent_close__se2Va"};